<div class="header">
  <div class="mission-info">
    <img src="assets/images/help-icon.svg" (click)="navigateToMissionInfo()"/>
    <div class="name">
      <a>{{ 'MISSION.LABEL' | translate }}</a>
      <a class="mission-name">{{ mission ? mission.missionName : 'MISSION.NO_MISSION' | translate }}</a>
    </div>
  </div>

  @if (mission && mission.checkingIsDone) {
    <div class="warning">
      <img src="assets/images/error-icon.svg"/>
      <a>{{ 'MISSION.MISSION_IN_PROGRESS' | translate }}</a>
    </div>
  }

  @if (mission) {
    <div class="status">
      <img src="assets/images/team.svg"/>
      <svg viewBox="-1 -1 2 2">
        <circle cx="0" cy="0" r="0.5" stroke="none" stroke-width="3"
          [attr.fill]="getStatusColor(mission.teamstatus, false)"
          (click)="navigateToTeam()"/>
      </svg>
      <img src="assets/images/truck.svg"/>
      <svg viewBox="-1 -1 2 2">
        <circle cx="0" cy="0" r="0.5" stroke="none" stroke-width="3"
          [attr.fill]="getStatusColor(mission.productstatus, true)"
          (click)="navigateToProduct()"/>
      </svg>
      <img src="assets/images/tools.svg"/>
      <svg viewBox="-1 -1 2 2">
        <circle cx="0" cy="0" r="0.5" stroke="none" stroke-width="3"
          [attr.fill]="getStatusColor(mission.materialstatus, true)"
          (click)="navigateToMaterial()"/>
      </svg>
      <img src="assets/images/support.svg"/>
      <svg viewBox="-1 -1 2 2">
        <circle cx="0" cy="0" r="0.5" stroke="none" stroke-width="3"
          [attr.fill]="getStatusColor(mission.supportstatus, false)"
          (click)="navigateToSupport()"/>
      </svg>
    </div>
  }
</div>

<div class="content">
  @if (mission) {
    <router-outlet></router-outlet>
  }
</div>
